import React from "react";
import { toast } from "sonner";
import { useCart, effPrice } from "@/context/CartContext";

const fmt = (cents) => `$${(cents / 100).toFixed(2)}`;

export default function ProductCard({ product }) {
  const { addItem, setDrawerOpen } = useCart();
  const soldOut = product.stock !== null && product.stock !== undefined && product.stock <= 0;
  const lowStock = !soldOut && product.stock !== null && product.stock !== undefined && product.stock <= 5;
  const onSale = product.sale_price_cents && product.sale_price_cents < product.price_cents;

  const handleAdd = () => {
    addItem(product.product_id);
    toast.success(`${product.name} added to cart`, {
      action: { label: "View Cart", onClick: () => setDrawerOpen(true) },
    });
  };

  return (
    <div
      data-testid={`product-card-${product.product_id}`}
      className={`bg-neutral-900 border rounded p-5 flex flex-col justify-between transition-colors ${
        soldOut ? "border-neutral-800 opacity-70" : "border-neutral-800 hover:border-neutral-300/50"
      }`}
    >
      <div>
        <div className="aspect-square w-full rounded border border-neutral-800 relative overflow-hidden mb-4 group">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className={`absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-500 ${
              soldOut ? "opacity-40 grayscale" : "opacity-75 group-hover:opacity-100 group-hover:scale-105"
            }`}
          />
          <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-neutral-950/80 rounded text-[10px] text-white font-mono uppercase">
            {product.tag}
          </div>
          {onSale && !soldOut && (
            <div
              data-testid={`sale-badge-${product.product_id}`}
              className="absolute top-2 right-2 px-2 py-1 bg-white text-neutral-950 text-[10px] font-mono font-bold uppercase rounded"
            >
              Sale
            </div>
          )}
          {soldOut && (
            <div
              data-testid={`sold-out-badge-${product.product_id}`}
              className="absolute top-2 right-2 px-2 py-1 bg-white text-neutral-950 text-[10px] font-mono font-bold uppercase rounded"
            >
              Sold Out
            </div>
          )}
        </div>
        <h3 className="font-bold text-sm text-neutral-100">{product.name}</h3>
        <p className="text-xs text-neutral-400 mt-1">{product.description}</p>
        {lowStock && (
          <p data-testid={`low-stock-${product.product_id}`} className="text-[10px] font-mono uppercase text-neutral-300 mt-2">
            Only {product.stock} left
          </p>
        )}
      </div>
      <div className="mt-6 pt-4 border-t border-neutral-800 flex items-center justify-between">
        <span data-testid={`product-price-${product.product_id}`} className="font-mono text-base font-bold text-white">
          {onSale && (
            <span className="text-neutral-500 line-through text-xs mr-2 font-normal">{fmt(product.price_cents)}</span>
          )}
          {fmt(effPrice(product))}
        </span>
        <button
          data-testid={`add-to-cart-${product.product_id}`}
          onClick={handleAdd}
          disabled={soldOut}
          className={`text-xs font-bold uppercase px-3 py-1.5 rounded transition-colors ${
            soldOut
              ? "bg-neutral-800 text-neutral-500 cursor-not-allowed"
              : "bg-neutral-800 hover:bg-white hover:text-neutral-950"
          }`}
        >
          {soldOut ? "Sold Out" : "Buy"}
        </button>
      </div>
    </div>
  );
}
